
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"104","height":"104","viewBox":"0 0 104 104","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"104","height":"104","rx":"6","fill":"white"}}),_c('path',{attrs:{"d":"M52.0009 28H51.998C38.7432 28 27.998 38.7451 27.998 51.9999C27.998 65.2547 38.7432 75.9998 51.998 75.9998H52.0009C65.2557 75.9998 76.0009 65.2547 76.0009 51.9999C76.0009 38.7451 65.2557 28 52.0009 28Z","fill":"black"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51.2802 28C51.1593 37.7292 50.4953 43.1976 46.8459 46.8466C43.1965 50.4957 37.7277 51.1598 27.998 51.2807V52.7191C37.7277 52.84 43.1965 53.5042 46.8459 57.1532C50.4953 60.8023 51.1593 66.2704 51.2802 76H52.7186C52.8394 66.2704 53.5034 60.8023 57.1528 57.1532C60.8022 53.5042 66.271 52.84 76.0007 52.7191V51.2807C66.271 51.1598 60.8022 50.4957 57.1528 46.8466C53.5034 43.1975 52.8394 37.7292 52.7186 28H51.2802Z","fill":"white"}})])
          )
        }
      }
    